import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { FormBuilder, FormGroup } from '@angular/forms';
import { AlertDialogService } from 'src/app/services/alert-dialog.service';
import { ConstantsService } from 'src/app/services/constants.service';
import { DataService } from 'src/app/services/data.service';
import { SessionService } from 'src/app/services/session.service';
import { UtilityService } from 'src/app/services/utility.service';
import { DynamicFilterService } from '../dynamic-filter/dynamic-filter.service';
import { DynamicPopupComponent } from '../dynamic-popup/dynamic-popup.component';


@Component({
    selector: 'app-edit-onscreen-card',
    templateUrl: './edit-onscreen-card.component.html',
    styleUrls: ['./edit-onscreen-card.component.scss'],
})
export class EditOnScreenCardComponent implements OnInit, OnChanges {
    @Input() rawDataValue: any;
    @Input() formFields: any[] = [];

    @Output() updateFormData = new EventEmitter();
    @Output() closeEditOnSameScreen = new EventEmitter();
    @Output() dirtyState = new EventEmitter<boolean>();

    dynamicForm!: FormGroup;
    allRows: any = {};
    rawData: any;
    @Output() selectedrow = new EventEmitter<any>();
    isNextDisabled: boolean = false;
    showPreviousNext: boolean = true;
    isPreviousDisabled: boolean = false;
    isNextPreviousClicked: boolean = false;
    currentRowIndex: number = 0;
    pendingRawData: any = {};
    constructor(private fb: FormBuilder,
        private dataService: DataService,
        private cdr: ChangeDetectorRef,
        public dialog: MatDialog,
    ) { }

    ngOnInit() {
        this.dataService.getData().subscribe((rowDataToEdit) => {
            if (!rowDataToEdit) return; // 👈 prevent null first emit

            this.allRows = rowDataToEdit.allRows;
            this.rawData = rowDataToEdit.dataToEdit;
            this.currentRowIndex = rowDataToEdit.currentRowIndex;

            this.isPreviousDisabled = this.currentRowIndex == 0;
            this.isNextDisabled = !(this.allRows && this.allRows.length > 0) || (this.currentRowIndex == this.allRows.length - 1);
        })
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['formFields']) {
            this.buildForm();
        }

        if (changes['rawDataValue']) {
            this.patchFormWith(changes['rawDataValue'].currentValue);
        }
    }

    buildForm() {
        const group: any = {};

        this.formFields.forEach(field => {
            group[field.data_field_name] = [''];
        });

        this.dynamicForm = this.fb.group(group);

        this.dynamicForm.valueChanges.subscribe(() => {
            this.dirtyState.emit(this.dynamicForm.dirty);
        });

    }

    private patchFormWith(data: any) {

        if (!data || !this.dynamicForm) return;

        const patchObj: any = {};
        this.formFields.forEach(field => {
            patchObj[field.data_field_name] =
                data[field.data_field_name] || field.value || '';
        });

        this.dynamicForm.patchValue(patchObj, { emitEvent: false });
        this.dynamicForm.markAsPristine();
        this.dirtyState.emit(false);
        this.cdr.detectChanges();
    }


    submit() {

        if (!this.dynamicForm) {
            return;
        }

        if (!this.dynamicForm.dirty) {
            alert('No changes detected');
            return;
        }

        // ✅ Changes exist
        this.updateFormData.emit(this.dynamicForm.value);

        if (this.dynamicForm.value) {
            const msg = {
                message: `The data has been successfully updated.`,
                title: 'Success!',
                icon: 'check_circle',
                iconColor: '#3AC97c',
                confirmText: 'Ok'
            };

            this.dynamicConfirmDialog(msg).subscribe((result) => {
                if (result?.confirmed) {
                    this.dynamicForm.markAsPristine();
                }
            });
        }
        this.dirtyState.emit(false);

        this.cdr.detectChanges();
    }




    close() {
        if (this.dynamicForm?.dirty) {
            let msg = {
                title: `Alert!`,
                message: `You have unsaved changes. Are you sure you want to close?`,
                icon: 'alert', // Use relevant icons
                iconColor: '#E70D0D',
                cancelText: 'Cancel',
                confirmText: 'Confirm',
            }
            this.dynamicConfirmDialog(msg).subscribe(result => {
                if (result?.confirmed == true) {
                    this.dynamicForm.markAsPristine(); // optional
                    this.closeEditOnSameScreen.emit();
                }
            })
            return
        }
        this.closeEditOnSameScreen.emit();

    }


    getRecord(direction: 'next' | 'previous') {
        if (this.dynamicForm?.dirty) {
            let msg = {
                title: `Alert!`,
                message: `You have unsaved changes. Continue without saving?`,
                icon: 'delete', // Use relevant icons
                iconColor: '#E70D0D',
                cancelText: 'Cancel',
                confirmText: 'Continue',
            }
            this.dynamicConfirmDialog(msg).subscribe(result => {
                if (result?.confirmed == true) {
                    this.dynamicForm.markAsPristine(); // optional
                    this.dirtyState.emit(false);
                    this.navigateRecord(direction);
                }
            })
            return
        }
        this.navigateRecord(direction);
    }

    navigateRecord(direction: 'next' | 'previous') {

        if (direction === 'next') {
            this.currentRowIndex++;
        } else {
            this.currentRowIndex--;
        }

        // Boundaries
        if (this.currentRowIndex < 0) {
            this.currentRowIndex = 0;
            return;
        }

        if (this.currentRowIndex >= this.allRows.length) {
            this.currentRowIndex = this.allRows.length - 1;
            return;
        }

        const rowData = this.allRows[this.currentRowIndex];

        this.selectedrow.emit({
            index: this.currentRowIndex,
            data: rowData
        });

    }


    dynamicConfirmDialog(msg: any) {
        let dialogRef = this.dialog.open(DynamicPopupComponent, {
            maxWidth: "90vw",
            disableClose: true,
            panelClass: "du-custom-modalbox",
            data: {
                title: `${msg.title}`,
                message: `${msg.message}`,
                icon: msg.icon,    //this.processName.toLocaleLowerCase() === 'delete' ? 'delete' : this.processName.toLocaleLowerCase() === 'copy' ? 'content_copy' : 'edit', // Use relevant icons
                iconColor: msg.iconColor,       //this.processName.toLocaleLowerCase() === 'delete' ? 'warn' : 'primary',
                cancelText: msg.cancelText,
                confirmText: msg.confirmText,  //this.processName.toLocaleLowerCase() === 'delete' ? 'Delete' : 'Confirm',
            },
        });
        return dialogRef.afterClosed();
    }

}
